import { useEffect } from 'react';
import './MeetingWidget.scss';

const MeetingWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <div className="meeting-widget">
      <div className="container">
        <div className="client-review-title">
          <h4 data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
            Book a Call With Us
          </h4>
          <p data-aos="fade-up" data-aos-duration="1200" data-aos-once="true">
            Share your ideas and let’s discuss how we can build your online presence together.
          </p>
        </div>
        <div
          className="calendly-inline-widget"
          data-url="https://calendly.com/pixerfect/30min?text_color=103f57&primary_color=fac212"
          style={{ minWidth: '320px', height: '800px' }}></div>
      </div>
    </div>
  );
};

export default MeetingWidget;
